import React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import styles from "./VarinerTable.module.css";

/**
 * Get Field from object data.
 *
 * @param {string} row
 * @param {string} field
 * @returns Object Index Value.
 */
const getField = (row, field) => {
  const isObject = field.includes(".");

  const [stack, needle] = field.split(".");

  return isObject ? row?.[stack]?.[needle] ?? "--" : `${row?.[field] || 0}`;
};

const VarinerTable = ({ data, fields }) => {
  if (!data) return null;

  return (
    <div className={styles.wrapper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>index</TableCell>
            {fields.map((field, index) => (
              <TableCell key={index}>{`${field}`}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data?.map((row, index = 0) => (
            <TableRow key={`${index}-${row.id}`}>
              <TableCell key={index} component="th" scope="row">
                {index + 1}
              </TableCell>

              {fields.map((field, index) => (
                <TableCell key={index} component="th" scope="row">
                  {getField(row, field)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

VarinerTable.propTypes = {
  data: PropTypes.any,
  fields: PropTypes.any
};

export { VarinerTable };
